import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { toastSuccess } from 'ui/partials/Toast';

import c from '../utils/constants';

export default function useUpdateNotificationsStatus() {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const args = state;

  return useMutation({
    mutationFn: async (payload: {
      status: string;
      notificationIds: string[];
    }) => {
      const api = new Api(args);

      const data = await api.patch({
        url: `api/v1/notifications/${payload.status}`,
        payload: { notificationIds: payload.notificationIds },
      });

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [c.NOTIFICATIONS] });
      toastSuccess('Successfully updated notifications');
    },
  });
}
